import wrapCalculationId from './wrapId';

export default function calculationAsAnswer({ id }, result) {
  return {
    field_id: wrapCalculationId(id),
    value:    result
  };
}
